var React = require('react');
var cx = require('classnames');
var zxcvbn = require('zxcvbn');

var PasswordField = React.createClass({
    propTypes: {
        value: React.PropTypes.string,
        onChange: React.PropTypes.func
    },
    getInitialState: function () {
        return {
            strength: 0,
            hasValue: false
        };
    },
    clearPassword: function () {
        this.refs.password.getDOMNode().value = '';
        this.updatePasswordStrength();
    },
    getPassword: function () {
        return this.refs.password.getDOMNode().value;
    },
    render: function () {
        var hasValue = this.state.hasValue;
        var score = this.state.strength.score;

        var passwordStrengthText;
        if (hasValue && score < 3) {
            passwordStrengthText = "Your password is too weak. Add additional characters and avoid dictionary words to increase strength";
        } else if (hasValue && score < 4) {
            passwordStrengthText = "Your password is okay, but adding more characters or avoiding dictionary words will make it stronger.";
        }
        if (passwordStrengthText) {
            passwordStrengthText = <span className="help-block">{passwordStrengthText}</span>;
        }

        var classes = {
            "strength-0": hasValue && score == 0,
            "strength-1": hasValue && score == 1,
            "strength-2": hasValue && score == 2,
            "strength-3": hasValue && score == 3,
            "strength-4": hasValue && score == 4
        };

        return <div className={cx(classes)}>
            <input
                ref="password"
                className="form-control input-md"
                type="password"
                onChange={this.updatePasswordStrength}
                value={this.props.value}
                name={this.props.name}
            />
            {passwordStrengthText}
        </div>;
    },
    updatePasswordStrength: function () {
        var val = this.refs.password.getDOMNode().value;

        this.setState({
            strength: zxcvbn(val),
            hasValue: !!val
        });

        if (this.props.onChange) {
            this.props.onChange(this.getPassword());
        }
    }
});
module.exports = PasswordField;



// WEBPACK FOOTER //
// ./app/components/Form/PasswordField.js